export default __webpack_public_path__ + "static/N0116-79a4edafe29d5de457db64b531ef26ae.png";